import { html } from "lit-element";
import { InspxObjectBase } from './inspx-object-base.js';
import { SharedStyles } from '../styles/shared-styles.js';
import { CardStyles } from '../styles/card-styles.js';
import { keyboardArrowDown, keyboardArrowUp } from '../styles/icons.js';


class InspxCardGroup extends InspxObjectBase {
	shouldUpdate() {
		return this.data && this.parts;
	}

	render() {
		const collapseButton = this.collapsed ? keyboardArrowDown : keyboardArrowUp;

		return html`
			${SharedStyles}
            ${CardStyles}
            <style>
                .separator {
                    color: var(--primary-color);
                    margin-bottom: 10px;
                    border-bottom: 1px solid var(--primary-color);
                    display: flex;
                    justify-content: space-between;
                    cursor: pointer;   
                }

                .button {
                    fill: var(--primary-color);
                }
            </style>

			<div class="separator" ?collapsed="${this.collapsed}" @click="${this.collapserClickHandler}">
				${this.cardtitle}
                <div class="button">${collapseButton}</div>
			</div>
			<div class="c" ?hidden="${this.collapsed}">
				${this.parts.map(p => this.renderField(p))}
			</div>
		`;
	}

	collapserClickHandler() {
		this.collapsed = !this.collapsed;
		this.requestUpdate();
	}

	constructor() {
		super();
		this.collapsed = false;
	}
}

window.customElements.define('inspx-card-group', InspxCardGroup);
